<template>

  <div class="select-input">
    <select v-model="selectedFilter" v-on:change="filterRsvp">
      <option value="-1" selected>Select a filter</option>
      <option v-for="(filter, index) in filters" :value="index">
        {{ filter.name }}
      </option>
    </select>
    <i class="fas fa-caret-down"></i>
  </div>
</template>

<script>
import ApiRoutingReservation from '@/modules/api/routing/reservations'
export default {
  name: 'table-filter',
  computed: {
    filters () { return this.$store.state.routing.reservationFilters },
    selectedFilter: {
      get () { return this.$store.state.routing.selectedFilter },
      set (value) { this.$store.commit('routing/setSelectedFilter', parseInt(value)) }
    }
  },
  methods: {
    filterRsvp () {
      let self = this
      if (self.selectedFilter !== -1) {
        self.$plugins.storage.set('ADMIN_ROUTING_FILTER', self.filters[self.selectedFilter].id)
      } else {
        self.$plugins.storage.remove('ADMIN_ROUTING_FILTER')
      }
      self.$store.commit('routing/resetReservationsPaging')
      self.$store.commit('routing/resetPackagePaging')
      ApiRoutingReservation.getReservations(this, r => {}, false)
      ApiRoutingReservation.getPackages(this, r => {}, false)
    }
  }
}
</script>

<style lang="scss" scoped>
.select-input{
  width: 30%;
  padding: 0;
  position: relative;

  & select {
    display: inline-block;
    width: 100%;
    height: 100%;
    outline: 0;
    border: 1px solid rgba(0,0,0,0.15);
    border-radius: 0;
    appearance: none;
    margin-left: -5px;
    background-color: #fff;
    padding: 0 30px 0 15px;
    border-right: 1px solid rgba(0,0,0,0.15);
    border-top: 0;
  }
  & i{
    position: absolute;
    top: 15px;
    right: 15px;
    color: #aaa;
  }
}

@media only screen and (max-width: 430px) {
  .select-input {
    width: 50%;

    select {
      margin: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Routing/TableFilter.vue